"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductTiles = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Clear = require("../../base-components/Clear/Clear");
var _MatchHeight = require("../../utils/MatchHeight");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
var _CardProductTile = require("./CardProductTile/CardProductTile");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CardProductTiles = exports.CardProductTiles = function CardProductTiles(_ref) {
  var title = _ref.title,
    styles = _ref.styles,
    products = _ref.products,
    Component = _ref.Component,
    namespace = _ref.namespace,
    qeId = _ref.qeId,
    collapsableOnMobile = _ref.collapsableOnMobile;
  return /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeightProvider, {
    className: styles.tilesContainer,
    qeId: qeId
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.cardTilesTitle,
    "data-qe-id": qeId ? "".concat(qeId, "__title") : undefined
  }, title, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.titleCardCount
  }, "(", products.length, ")")), /*#__PURE__*/_react["default"].createElement(Component, {
    className: (0, _classnames["default"])(styles.tiles),
    namespace: namespace
  }, products.map(function (product, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      name: "Card Tile",
      key: "".concat(index + 1, "_match-height"),
      className: styles.tile
    }, /*#__PURE__*/_react["default"].createElement(_CardProductTile.CardProductTile, _extends({
      key: "".concat(product.title, "__").concat(index + 1),
      styles: styles,
      dtm: product.dtm
    }, product, {
      namespace: (0, _PropertyProvider.NS)(namespace, 'card-product'),
      qeId: qeId ? "".concat(qeId, "__tile").concat(index + 1) : undefined,
      cardIndex: index,
      collapsableOnMobile: collapsableOnMobile
    })));
  }), /*#__PURE__*/_react["default"].createElement(_Clear.Clear, null)));
};
var _CardProductTile$prop = _CardProductTile.CardProductTile.propTypes,
  styles = _CardProductTile$prop.styles,
  allCardProductPropTypesExceptStyles = _objectWithoutProperties(_CardProductTile$prop, ["styles"]);
CardProductTiles.propTypes = {
  title: _propTypes["default"].node,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  products: _propTypes["default"].arrayOf(_propTypes["default"].shape(allCardProductPropTypesExceptStyles)).isRequired,
  Component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string,
  collapsableOnMobile: _propTypes["default"].bool
};
CardProductTiles.defaultProps = {
  title: undefined,
  styles: {},
  Component: 'div',
  namespace: '',
  qeId: undefined,
  collapsableOnMobile: false
};